export const ASM_VALIDATION_CONFIGURATION_TYPE = 'asm_validation_scoping_settings';
export const CREDITS = 'credits';
export const COINS = 'coins';
export const ASSET_LIMIT = 'asset_limit';
export const CONTRACT = 'contract';
export const USER_COUNT_LIMIT = 'user_count_limit';
export const TH_USER_COUNT_LIMIT = 'threat_hunting_user_limit';
export const SUPPLY_CHAIN_VENDOR_LIMIT = 'supply_chain_vendor_limit';
export const REPORT_TENANT_LIMIT = 'report_tenant_limit';
export const CHILD_TENANT_CAPACITY = 'child_tenant_capacity';
export const WHITE_LABEL_OWNER = 'white_label_owner';
export const WHITE_LABEL = 'white_label';
export const WHITE_LABEL_UI = 'white_label_ui';
export const OWNERS = 'owners';
export const ELEARNING_PLATFORMS = 'elearning-platforms';

export const FAVICONS = 'favicon';
export const PHISHING_RESOURCE_MATCHING = 'phishing.resource_matching';
export const USER_SELF_RESET_PW = 'self_password_reset';
export const ACTIVE_VULNERABILITY_SCAN = 'avs';

export const ASM_DISCOVERY_CONFIG = 'asm_discovery_configuration';

export const ALERTS_CALLBACK = 'alerts.callback';
export const CUSTOMER_ALERT_POLICY = 'customer_alert_policy';
export const ALERTS_AUTOMATIC = 'alerts.automatic';
export const ALERT_NOTIFICATION_DETAILS = 'alert_notification_details';

export const CHAT_APP_CONFIGURATION = 'notifications';
export const STRATEGIC_CHAT_APP_CONFIGURATION = 'strategic_intelligence_chat_apps_notification';
export const SALESFORCE_SYNC = 'sync_from_sf';
export const USER_CENTER_SYNC = 'uc_sync';
export const MSSP_INHERITED_CREDITS = 'mssp_inherited_credits';
export const IOC_INTEL_ENRICHMENT_API_RATE_LIMIT = 'ioc_intel_enrichment_api_rate_limit';
export const EARLY_ACCESS = 'early_access';
